import { memo, ReactNode, useMemo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import './style.scss';

interface IProps {
  id?: string;
  name: Icons;
  color?: string;
  size?: number;
  disabled?: boolean;
  onPress?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
  disabledClassName?: string;
  style?: object;
  //
  children?: ReactNode;
}

const Icon: React.FC<IProps> = (props: IProps): JSX.Element => {
  const onPress = (e: React.MouseEvent<HTMLDivElement>) => {
    if (props.disabled) return;
    if (props.onPress) props.onPress(e);
  };

  const iconClassName = useMemo((): string => {
    let className: string = `icons-icon icon-${props.name}`;

    if (props.className) className += ` ${props.className}`;
    if (props.disabled && props.disabledClassName) className += ` ${props.disabledClassName}`;

    return className;
  }, [props.name, props.className, props.disabled, props.disabledClassName]);

  return (
    <i
      id={props.id}
      onClick={onPress}
      style={{
        fontSize: props.size,
        width: props.size,
        height: props.size,
        ...(props.color ? { color: props.color } : {}),
        ...props.style,
      }}
      className={iconClassName}
    >
      {props.children}
    </i>
  );
};

export default memo(Icon);
